<template>
  <path
    d="M20 2.00018H4C2.9 2.00018 2 2.90018 2 4.00018V22.0002L6 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00018C22 2.90018 21.1 2.00018 20 2.00018ZM12 11.0002C11.45 11.0002 11 10.5502 11 10.0002V6.00018C11 5.45018 11.45 5.00018 12 5.00018C12.55 5.00018 13 5.45018 13 6.00018V10.0002C13 10.5502 12.55 11.0002 12 11.0002ZM13 15.0002H11V13.0002H13V15.0002Z"
  />
</template>
